import React from 'react';
import PropTypes from 'prop-types';

import { SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS } from 'common/applicationAssemblyLineConstants';

import {
  HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
  HOUSEHOLD_APPLICATION_STATUS_PENDING_INTERNAL_REVIEW,
} from 'common/householdConstants';

import {
  RENTAL_APPLICATION_STEP_ADDITIONAL_INFO,
  getRentalApplicationUrl,
} from 'common/householdApplication/rentalApplicationHelpers';

import { makeApplicationStatusList } from 'common/householdApplication/applicationHelpers';

import SrLink from 'client/components/SrLink/SrLink';
import SrApplicationAssemblyLineStepMoveInDate from 'client/components/SrApplicationAssemblyLine/SrApplicationAssemblyLineStepMoveInDate/SrApplicationAssemblyLineStepMoveInDate';
import SrApplicationAssemblyLineStepIncomeVerification from 'client/components/SrApplicationAssemblyLine/SrApplicationAssemblyLineStepIncomeVerification/SrApplicationAssemblyLineStepIncomeVerification';

import './SrRenterApplicationAdditionalInformation.less';

const validApplicationStatusList = makeApplicationStatusList({
  fromApplicationStatus: HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
  toApplicationStatus: HOUSEHOLD_APPLICATION_STATUS_PENDING_INTERNAL_REVIEW,
});

const SrRenterApplicationAdditionalInformation = ({
  listing,
  householdApplication,
  tenantScreeningCriteria,
}) => {
  if (!validApplicationStatusList.includes(householdApplication.status)) {
    return null;
  }

  const assemblyLine = {
    listing,
    tenantScreeningCriteria,
  };

  const moveInDateStatus = SrApplicationAssemblyLineStepMoveInDate.getStatus({
    householdApplication,
    assemblyLine,
  });
  const incomeVerificationStatus = SrApplicationAssemblyLineStepIncomeVerification.getStatus({
    householdApplication,
    assemblyLine,
  });

  if (
    moveInDateStatus !== SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS &&
    incomeVerificationStatus !== SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS
  ) {
    return null;
  }

  const rentalApplicationUrl = getRentalApplicationUrl({
    userId: householdApplication.userId,
    listingId: listing.id,
    rentalApplicationStepId: RENTAL_APPLICATION_STEP_ADDITIONAL_INFO,
  });

  return (
    <SrLink to={rentalApplicationUrl} styleName="container">
      <span styleName="title">additional info required</span>
      <span styleName="text">
        Your application requires more information to continue processing.
      </span>

      <div styleName="box">
        <span styleName="cta">Add Required Information</span>
      </div>
    </SrLink>
  );
};

SrRenterApplicationAdditionalInformation.displayName = 'SrRenterApplicationAdditionalInformation';

SrRenterApplicationAdditionalInformation.propTypes = {
  listing: PropTypes.object.isRequired,
  householdApplication: PropTypes.object.isRequired,
  tenantScreeningCriteria: PropTypes.object.isRequired,
};

export default SrRenterApplicationAdditionalInformation;
